<template>
  <div class="menu">
    <slot></slot>
  </div>
</template>
